import BasicType from 'src/entities/basic-types/BasicType';

export default class CustomerPaymentMethod extends BasicType {
    public id: number;
    public applicableForPartialPayment: boolean;
    public normalizedName: string;
    public localizedName: string;

    constructor(json: any) {
        super();
        this.id = json.id;
        this.applicableForPartialPayment = json.applicableForPartialPayment;
        this.normalizedName = json.normalizedName;
        this.localizedName = json.localizedName;
    }

    public toString(): string {
        return `${this.localizedName}`;
    }

    public equals(method: CustomerPaymentMethod): boolean {
        return this.normalizedName === method.normalizedName;
    }

    public isPartial(): boolean {
        return this.normalizedName.includes('_PARTIAL');
    }
}
